/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './actionTypes';
const initialState = {
  planType: [],
  rebateProgramList: [],
  rebateProgramNameValue: '',
  selectedPlanType: '',
  rebateProgramValue: '',
  errors: [],

  quarterValue: '',
  invoiceOption: '1',
  formerRetains: true,

  zeroUraMaxQuarter: '',
  invoiceResult: [],
  invoiceResultUnchecked: [],
  invoiceHandle: {
    None: true,
    Mailed: true,
    Forgiven: false,
    Retained: false,
  },
  searchScreenRedux: {
    rebateProgramValue: '',
    rebateProgrameName: '',
    rebateProgramList: [],
    quarterValue: '',
    formerRetains: true,
    invoiceHandle: {
      None: true,
      Mailed: true,
      Forgiven: false,
      Retained: false,
    },
    invoiceOption: '1',
    invoiceResult: [],
    invoiceResultUnchecked: [],
  },
  displayObj: {
    rebateProgramValue: '',
    rebateProgrameName: '',
    rebateProgramList: [],
    quarterValue: '',
    formerRetains: true,
    invoiceHandle: {
      None: true,
      Mailed: true,
      Forgiven: false,
      Retained: false,
    },
    invoiceOption: '1',
    invoiceResult: [],
    invoiceResultUnchecked: [],
  },
  displayHeaderObj: [],
};
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    // case ActionTypes.GET_REBATE_PROGRAM_UNALLOACTED_BALANCE:
    //   return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY:
      let getPgmValSingleHeader = Object.keys(action.payload)[0];
      if (state.displayHeaderObj.length != 0) {
        let main = state?.displayHeaderObj?.forEach(function (obj) {
          delete obj[getPgmValSingleHeader];
        });
      }
      return {
        ...state,
        displayHeaderObj: [...state.displayHeaderObj, action.payload],
      };
    case ActionTypes.IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY:
      return { ...state, isLoading: action.isLoading };
    case ActionTypes.GET_MAX_QUARTER_INVOICE_REGISTER:
      return {
        ...state,
        zeroUraMaxQuarter: action.zeroUraMaxQuarter,
      };
    case ActionTypes.GET_INVOICE_RESULT:
      let getPgmValSingle = Object.keys(action.invoiceResult)[0];
      if (state.invoiceResult.length != 0) {
        let main = state?.invoiceResult?.forEach(function (obj) {
          delete obj[getPgmValSingle];
        });
      }
      return {
        ...state,
        invoiceResult: [...state.invoiceResult, action.invoiceResult],
      };
    case ActionTypes.GET_INVOICE_RESULT_UNCHECKED:
      let getPgmValRegSingle = Object.keys(action.invoiceResultUnchecked)[0];
      if (state.invoiceResultUnchecked.length != 0) {
        let main = state?.invoiceResultUnchecked?.forEach(function (obj) {
          delete obj[getPgmValRegSingle];
        });
      }
      return {
        ...state,
        invoiceResultUnchecked: [
          ...state.invoiceResultUnchecked,
          action.invoiceResultUnchecked,
        ],
      };
    case ActionTypes.REFRESH_INVOICE_REGISTER:
      return {
        ...initialState,
        searchScreenRedux: { ...state.searchScreenRedux, ...action.payload },
      };
    case ActionTypes.REFRESH_INVOICE_REGISTER_DISPLAY:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.NO_DATA_MESSAGE:
      return { ...state, noDataMessage: action.noDataMessage };
    default:
      return state;
  }
};

export default reducer;
